/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * User Preferences State
 *
 * @type {Object}
 */
const state = {
    data: {},
    options: {
        decimals: [0, 1, 2],
        monetaryUnits: [
            'dollars',
            'thousands',
            'millions'
        ]
    },
    selectedDecimalPreference: 2,
    selectedUnitPreference: 'dollars'
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/user/preferences/state.js